import { gql } from 'apollo-angular';

export const userModuleAnswerQuestion = gql`
	fragment UserModuleAnswerQuestion on ModuleQuestionOutput {
		id
		name
		type
		cssClass
		position
		condition
		uniqFilter
		gridClass
		canDuplicate
		canAddSibling
		maxDuplicates
		sourceModuleId
		updateTimestamp
		sourceQuestionId
		localizations {
			locale
			question
			addSiblingLabel
			addDuplicateLabel
		}
	}
`;

export const modulePageQuestions = gql`
	fragment ModulePageQuestions on ModuleQuestionOutput {
		id
		name
		type
		cssClass
		position
		condition
		uniqFilter
		gridClass
		canDuplicate
		canAddSibling
		maxDuplicates
		sourceModuleId
		updateTimestamp
		sourceQuestionId
		fields {
			id
			name
			type
			value
			position
			minLines
			condition
			gridClass
			isRequired
			isExtraField
			optionsGroup
			optionsScript
			updateTimestamp
			optionsGridClass
			localizations {
				label
				locale
				placeholder
			}
		}
		localizations {
			locale
			question
			addSiblingLabel
			addDuplicateLabel
		}
	}
`;
